<template>
  <div class="fm-breadcrumb row">
    <div class="col-md-9">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb" v-bind:class="[manager === activeManager ? 'active-manager' : 'bg-light']">
          <li class="breadcrumb-item" v-on:click="selectMainDirectory">
            <span class="root">
              <!-- {{ $t('navbar.breadcrumb.allFiles') }} -->
              <i class="bx bxs-home-circle"></i>
            </span>
          </li>
          <li class="breadcrumb-item text-truncate" v-for="(item, index) in breadcrumb" v-bind:key="index"
            v-bind:class="[breadcrumb.length === index + 1 ? 'active' : '']">
            <span v-if="item !== 'searchResult'" class="breadcrumb-item-text" v-on:click="selectDirectory(index)"
              v-bind:class="[breadcrumb.length === index + 1 ? 'active' : '']" style="cursor: pointer">
              {{ item }}
            </span>
            <span v-else class="breadcrumb-item-text"
              v-bind:class="[breadcrumb.length === index + 1 ? 'active-result' : '']">
              {{ $t('filemanager.location.search_result.result') }}
            </span>
          </li>
        </ol>
      </nav>
    </div>

    <div class="col-md-3">
      <div class="btn-group mr-2" role="group">
        <b-dropdown menu-class="dropdown-menu-md" right class="card-drop" variant="left">
          <template v-slot:button-content>
            <i class="fas fa-plus" style="font-size: 18px" />
          </template>

          <div class="px-lg-2 pr-4">
            <div class="row no-gutters">
              <div class="col-12">
                <a class="dropdown-icon-item text-left pl-4" @click.prevent="showModal('NewFolder')">
                  <span>
                    <img class="mr-2" style="width:40px:height:40px" src="../../assets/folder.png" alt="Word" />
                    {{ $t('filemanager.create.folder') }}
                  </span>
                </a>
              </div>
              <div class="col-12">
                <a class="dropdown-icon-item text-left pl-4" @click.prevent="showModal('NewWordFile')">
                  <span>
                    <img class="mr-2" style="width:40px:height:40px" src="../../assets/icons/word.svg" alt="Word" />
                    {{ $t('filemanager.create.word') }}
                  </span>
                </a>
              </div>
              <div class="col-12">
                <a class="dropdown-icon-item text-left pl-4" @click.prevent="showModal('NewExcelFile')">
                  <span>
                    <img class="mr-2" style="width:40px:height:40px" src="../../assets/icons/excel.svg" alt="Excel" />
                    {{ $t('filemanager.create.excel') }}
                  </span>
                </a>
              </div>
              <div class="col-12">
                <a class="dropdown-icon-item text-left pl-4" @click.prevent="showModal('NewPresentationFile')">
                  <span>
                    <img class="mr-2" style="width:40px:height:40px" src="../../assets/icons/powerpoint.svg"
                      alt="Powerpoint" />
                    {{ $t('filemanager.create.powerPoint') }}
                  </span>
                </a>
              </div>
              <div class="col-12">
                <a class="dropdown-icon-item text-left pl-4" @click.prevent="showModal('NewFile')">
                  <span>
                    <img class="mr-2" style="width:40px:height:40px" src="../../assets/icons/form.png"
                      alt="Powerpoint" />
                    {{ $t('filemanager.create.form') }}
                  </span>
                </a>
              </div>
            </div>
          </div>
        </b-dropdown>
        <button type="button" class="btn btn-light btn-md" v-bind:disabled="backDisabled"
          :title="$t('navbar.buttons.prev')" v-on:click="historyBack()">
          <i class="fas fa-step-backward" />
        </button>
        <button type="button" class="btn btn-light btn-md" v-bind:disabled="forwardDisabled"
          :title="$t('navbar.buttons.next')" v-on:click="historyForward()">
          <i class="fas fa-step-forward" />
        </button>
        <button type="button" class="btn btn-light btn-md d-none d-lg-block" v-bind:class="[viewType === 'table' ? 'active' : '']"
          v-on:click="selectView('table')" :title="$t('navbar.buttons.list')">
          <i class="fas fa-th-list" />
        </button>
        <button role="button" class="btn btn-light btn-md d-none d-lg-block" v-bind:class="[viewType === 'grid' ? 'active' : '']"
          v-on:click="selectView('grid')" :title="$t('navbar.buttons.grid')">
          <i class="fas fa-th" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Breadcrumb',
  props: {
    manager: { type: String, required: true },
  },
  computed: {
    /**
     * Back button state
     * @returns {boolean}
     */
    backDisabled() {
      return !this.$store.state.left.historyPointer;
    },

    /**
     * Forward button state
     * @returns {boolean}
     */
    forwardDisabled() {
      return this.$store.state.left.historyPointer
          === this.$store.state.left.history.length - 1;
    },

    /**
     * Active manager name
     * @returns {default.computed.activeManager|(function())|string|activeManager}
     */
    activeManager() {
      return this.$store.state.activeManager;
    },

    /**
     * Selected Disk for this manager
     * @returns {default.computed.selectedDisk|(function())|default.selectedDisk|null}
     */
    selectedDisk() {
      return this.$store.state.manager.selectedDisk;
    },

    /**
     * Selected directory for this manager
     * @returns {default.computed.selectedDirectory|(function())|default.selectedDirectory|null}
     */
    selectedDirectory() {
      return this.$store.state.manager.selectedDirectory;
    },

    /**
     * Breadcrumb
     * @returns {*}
     */
    breadcrumb() {
      return this.$store.getters[`${this.manager}/breadcrumb`];
    },

    /**
     * Selected file
     * @returns {*}
     */
    selectedItem() {
      return this.$store.getters["selectedItems"][0];
    },

    /**
     * Manager view type - grid or table
     * @returns {default.computed.viewType|(function())|string}
     */
    viewType() {
      return this.$store.state.left.viewType;
    },
  },
  methods: {
    /**
     * Load selected directory
     * @param index
     */
    selectDirectory(index) {
      const path = this.breadcrumb.slice(0, index + 1).join('/');

      // only if this path not selected
      if (path !== this.selectedDirectory) {
        // load directory
        this.$store.dispatch(`${this.manager}/selectDirectory`, { path, history: true });
      }
    },
    
    /**
     * Show modal window
     * @param modalName
     */
    showModal(modalName) {
      // show selected modal
      this.$store.commit('modal/setModalState', {
        modalName,
        show: true,
      });
    },

    /**
     * Select main directory
     */
    selectMainDirectory() {
      this.$store.dispatch(`${this.manager}/selectDirectory`, { path: null, history: true });
    },

    /**
     * Select view type
     * @param type
     */
    selectView(type) {
      localStorage.setItem('view', type);
      if (this.viewType !== type) this.$store.commit(`${this.activeManager}/setView`, type);
    },

    /**
     * History back
     */
    historyBack() {
      this.$store.dispatch(`${this.activeManager}/historyBack`);
    },

    /**
     * History forward
     */
    historyForward() {
      this.$store.dispatch(`${this.activeManager}/historyForward`);
    },
  },
};
</script>

<style lang="scss">
  .fm-breadcrumb {

    .breadcrumb {
      flex-wrap: nowrap;
      padding: 0.4rem 0.3rem;

      .root {
        background-color: #566a9e;
        padding: 2px;
        padding-left: 8px;
        padding-right: 8px;
        margin-left: 5px;
        margin-right: 5px;
        color: #ebeffc;
        border-radius: 8px;
      }

      &.active-manager {
        background-color: #f6f9fd;
      }
      .breadcrumb-item {
        .breadcrumb-item-text {
          color: #101f47;
          padding: 2px;
          padding-left: 8px;
          padding-right: 8px;
          margin-left: 5px;
          margin-right: 5px;
          font-weight: 500;
          color: #252936;
          border-radius: 8px;
          &.active {
            // background-color: #071260;
            color: #101f47;
          }
          &.active-result {
            background-color: #00BCB1;
            color: #f2f4f8;
          }
        }
      }
      .breadcrumb-item:not(.active):hover {
          cursor: pointer;
          font-weight: normal;
          color: #f0f3fc;
          .breadcrumb-item-text {
            background-color: #778abb;
            padding: 2px;
            padding-left: 8px;
            padding-right: 8px;
            margin-left: 5px;
            margin-right: 5px;
            color: #eef0f7;
            border-radius: 8px;
          }
      }
    }
  }
  .dropdown-icon-item {
    cursor: pointer;
  }
</style>
